import { FC } from "react";
import { Redirect } from "react-router-dom";
import withCompositeResource, { WrappedComponentProps } from "@/components/recource/CompositeResource";
import { useHasFeature } from "@/utils/useHasFeature";

const SecureAIComposite : FC<WrappedComponentProps> = ({
  children,
}) => {
  const hasFeature = useHasFeature()
  
  if (false && !hasFeature.OnDataSecureAI) {
    return (
      hasFeature.requested ? <Redirect to="/" /> : null
    )
  }
  return (
    <>{children}</>
  )
}

export default withCompositeResource(SecureAIComposite);